<template>
  <el-dialog
    :visible="visible"
    :title="$l('INDEX.tips_question_title') || '提示信息'"
    width="30%"
    custom-class="can-reload-dialog"
    :before-close="() => cancel()"
    v-el-dialog-drag
  >
    <span>{{ '此表单有改动, 是否保存?' }}</span>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancel()" size="small">
        {{ $l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-button @click="notSave()" size="small">
        {{ $l('INDEX.btn_no_save') || '不保存' }}
      </el-button>
      <el-button @click="save()" type="primary" size="small">
        {{ $l('INDEX.btn_save') || '保存' }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
    }
  },
  watch: {
    $route: {
      handler() {
        this.cancel()
      },
      deep: true,
    },
  },
  methods: {
    open() {
      this.visible = true
      return new Promise((resolve, reject) => {
        this.promiseStatus = { resolve, reject }
      })
    },
    cancel() {
      this.close()
      this.promiseStatus && this.promiseStatus.reject()
    },
    close() {
      this.visible = false
      document.body.removeChild(this.$el)
    },
    notSave() {
      this.close()
      this.promiseStatus && this.promiseStatus.resolve(false)
    },
    save() {
      this.close()
      this.promiseStatus && this.promiseStatus.resolve(true)
    },
  },
}
</script>
